import React from 'react';
import PropTypes from 'prop-types';

/**
 * WeeklySummary - Summary card showing weekly activity stats
 *
 * @param {Object} props
 * @param {Object} props.trends - Trend data (formsLast7d)
 * @param {Object} props.stats - Dashboard stats (averageFormsPerDay, activeSessions)
 * @param {boolean} props.show - Whether to show the component
 */
const WeeklySummary = ({ trends, stats, show }) => {
  if (!show || !trends.formsLast7d || trends.formsLast7d <= 0) {
    return null;
  }

  return (
    <div className="summary-card">
      <div className="summary-header">
        <h3>📈 Weekly Activity Summary</h3>
      </div>
      <div className="summary-stats">
        <div className="summary-stat">
          <span className="summary-value">{trends.formsLast7d}</span>
          <span className="summary-label">Forms This Week</span>
        </div>
        <div className="summary-stat">
          <span className="summary-value">{stats.averageFormsPerDay || 0}</span>
          <span className="summary-label">Daily Average</span>
        </div>
        <div className="summary-stat">
          <span className="summary-value">{stats.activeSessions || 0}</span>
          <span className="summary-label">Online Now</span>
        </div>
      </div>
    </div>
  );
};

WeeklySummary.propTypes = {
  trends: PropTypes.shape({
    formsLast7d: PropTypes.number,
  }).isRequired,
  stats: PropTypes.shape({
    averageFormsPerDay: PropTypes.number,
    activeSessions: PropTypes.number,
  }).isRequired,
  show: PropTypes.bool,
};

WeeklySummary.defaultProps = {
  show: true,
};

export default WeeklySummary;
